module.exports = __webpack_public_path__ + "img/dp7.23724139.jpeg";